import { Space } from '@mantine/core';

import PageLayout from 'PageLayout';
import { EPageTitle } from 'libs/ui';
import { humanizeText } from 'utils/utility';

import BookingFilter from '../Components/BookingFilter';
import useOnlineBooking from '../hooks/useOnlineBooking';
import HotelBookingListing from '../Components/BookingListing/HotelBookingListing';
import FlightBookingListing from '../Components/BookingListing/FlightBookingListing';

export default function BookingList() {

    const {
        status,
        isBtnLoading,
        filterState,
        setFilterState,
        handleChangeFilter,
        handleSubmitFilter
    } = useOnlineBooking();


    return (
        <PageLayout>
            <EPageTitle title={`${humanizeText(status)} Booking`} />

            <BookingFilter
                filter={filterState}
                setFilter={setFilterState}
                btnLoading={isBtnLoading}
                onChange={(key, value) => handleChangeFilter(key, value as string)}
                onSubmit={() => handleSubmitFilter()}
                onReset={() => handleChangeFilter("default", "")}
            />

            <Space h="lg" />

            {
                filterState?.service?.value === "FLIGHT"
                    ?
                    <FlightBookingListing
                        filterState={filterState}
                    />
                    :
                    <HotelBookingListing
                        filterState={filterState}
                    />
            }
        </PageLayout>
    );

};